import type {SVGProps} from 'react'
import * as React from 'react'
const NoContentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="121" height="120" fill="none" viewBox="0 0 121 120" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.5 100.69C120.5 84.4067 93.6371 71.2068 60.5 71.2068C27.3629 71.2068 0.5 84.4067 0.5 100.69C0.5 116.972 120.5 116.972 120.5 100.69Z"
      fill="url(#paint0_linear_17513_7105)"
    />
    <g opacity="0.8">
      <g opacity="0.8">
        <path opacity="0.8" d="M15.5 83.3191V89.7846" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M15.3268 70.345C11.4058 74.4614 9.7149 77.5919 10.254 79.7367C11.0626 82.9539 14.2807 83.4484 15.0761 83.4484C15.8715 83.4484 20.5011 83.5095 20.5011 79.2214C20.5011 76.3627 18.7763 73.4039 15.3268 70.345Z"
          fill="#D2E4FF"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M101.707 81.8752V86.4011" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M101.705 72.7588C98.9606 75.6836 97.777 77.9079 98.1544 79.4319C98.7204 81.7177 100.973 82.0691 101.53 82.0691C102.087 82.0691 105.327 82.1125 105.327 79.0657C105.327 77.0346 104.12 74.9322 101.705 72.7588Z"
          fill="#D2E4FF"
        />
      </g>
      <g opacity="0.8">
        <path opacity="0.8" d="M112.742 88.0496V91.6056" stroke="#AECFFF" strokeWidth="2.66667" strokeLinecap="round" />
        <path
          opacity="0.8"
          d="M112.914 81.3794C110.823 83.5459 109.921 85.1936 110.208 86.3224C110.64 88.0157 112.356 88.276 112.78 88.276C113.204 88.276 115.674 88.3081 115.674 86.0512C115.674 84.5466 114.754 82.9894 112.914 81.3794Z"
          fill="#D2E4FF"
        />
      </g>
    </g>
    <path d="M34.9805 53.4368L58.0839 49.3103V72.7586H34.9805V53.4368Z" fill="url(#paint1_linear_17513_7105)" />
    <path d="M58.0859 49.3103L86.017 53.0875V74.4827H58.0859V49.3103Z" fill="url(#paint2_linear_17513_7105)" />
    <g filter="url(#filter0_f_17513_7105)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.707 71.0344H34.9269L53.2588 85.862L35.2516 85.1819L16.707 71.0344Z"
        fill="url(#paint3_linear_17513_7105)"
      />
    </g>
    <path d="M34.9805 53.4324L61.877 59.081V92.3979L34.9805 85.2119V53.4324Z" fill="url(#paint4_linear_17513_7105)" />
    <g filter="url(#filter1_f_17513_7105)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.3281 59.1379H61.8799L59.2106 74.1047L35.3281 67.9243V59.1379Z"
        fill="url(#paint5_linear_17513_7105)"
      />
    </g>
    <path d="M61.8789 59.1054L86.0168 53.0876V84.4361L61.8789 92.398V59.1054Z" fill="url(#paint6_linear_17513_7105)" />
    <g filter="url(#filter2_f_17513_7105)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.8789 59.1379H85.672V67.6887L64.0854 75.6796L61.8789 59.1379Z"
        fill="url(#paint7_linear_17513_7105)"
      />
    </g>
    <path
      d="M34.9821 53.4324L61.8786 59.1053L56.5314 71.3793L29.4648 64.3998L34.9821 53.4324Z"
      fill="url(#paint8_linear_17513_7105)"
    />
    <path
      d="M61.8789 59.1054L86.0169 53.0876L91.1725 63.9188L68.1706 71.3794L61.8789 59.1054Z"
      fill="url(#paint9_linear_17513_7105)"
    />
    <path d="M61.8789 59.1052L68.1706 71.3792L91.1725 63.9186" stroke="#E5F0FF" strokeWidth="0.666667" />
    <path
      opacity="0.603585"
      d="M61.8786 59.1052L56.5314 71.3792L29.4648 64.3997"
      stroke="#E6F0FF"
      strokeWidth="0.666667"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.877 59.1053L86.015 53.0875L58.0839 49.3103L34.9805 53.4324L61.877 59.1053Z"
      stroke="url(#paint10_linear_17513_7105)"
      strokeWidth="0.666667"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_f_17513_7105"
        x="15.3737"
        y="69.7011"
        width="39.2174"
        height="17.4943"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_7105" />
      </filter>
      <filter
        id="filter1_f_17513_7105"
        x="33.9948"
        y="57.8046"
        width="29.2174"
        height="17.6335"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_7105" />
      </filter>
      <filter
        id="filter2_f_17513_7105"
        x="60.5456"
        y="57.8046"
        width="26.4596"
        height="19.2084"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.666667" result="effect1_foregroundBlur_17513_7105" />
      </filter>
      <linearGradient
        id="paint0_linear_17513_7105"
        x1="60.5"
        y1="71.2068"
        x2="60.5"
        y2="109.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0EDFF" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_17513_7105"
        x1="36.6845"
        y1="64.931"
        x2="60.9851"
        y2="54.8361"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#B6D5FF" />
        <stop offset="1" stopColor="#E5F0FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_17513_7105"
        x1="58.0859"
        y1="58.0486"
        x2="86.017"
        y2="58.0486"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#ADD0FF" />
        <stop offset="1" stopColor="#CCE2FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_17513_7105"
        x1="41.4033"
        y1="78.0552"
        x2="41.8515"
        y2="79.6725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#418EFF" stopOpacity="0" />
        <stop offset="1" stopColor="#418EFF" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_17513_7105"
        x1="61.8311"
        y1="73.6667"
        x2="31.4978"
        y2="74.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A5C9FF" />
        <stop offset="1" stopColor="#EFF6FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_17513_7105"
        x1="48.5005"
        y1="74.3333"
        x2="54.8259"
        y2="59.566"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#418EFF" stopOpacity="0" />
        <stop offset="1" stopColor="#418EFF" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_17513_7105"
        x1="85.9756"
        y1="73.5011"
        x2="75.607"
        y2="59.5863"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4DCFF" />
        <stop offset="1" stopColor="#EFF6FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_17513_7105"
        x1="81.4996"
        y1="73.6666"
        x2="79.6049"
        y2="54.4408"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#418EFF" stopOpacity="0" />
        <stop offset="1" stopColor="#418EFF" stopOpacity="0.5" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_17513_7105"
        x1="44.1596"
        y1="63.8926"
        x2="45.5607"
        y2="59.4777"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#A5C9FF" />
        <stop offset="1" stopColor="#D0E3FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_17513_7105"
        x1="76.5257"
        y1="71.3794"
        x2="76.5257"
        y2="53.0876"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000184755" stopColor="#BAD6FF" />
        <stop offset="1" stopColor="#F0F6FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_17513_7105"
        x1="60.4977"
        y1="54.0274"
        x2="60.5067"
        y2="54.3939"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5F0FF" />
        <stop offset="1" stopColor="#F0F6FF" />
      </linearGradient>
    </defs>
  </svg>
)
export default NoContentIcon
